import { Component, inject, OnInit, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavbarComponent } from './features/navbar/navbar.component';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [NavbarComponent, RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  private readonly oidcService = inject(OidcSecurityService);

  readonly ready = signal(false);

  ngOnInit(): void {
    this.oidcService.checkAuth().subscribe(({ isAuthenticated }) => {
      const handler = isAuthenticated ? this.onAuthenticated : this.onUnauthenticated;
      handler.call(this);
    });
  }

  private onAuthenticated(): void {
    this.ready.set(true);
  }

  private onUnauthenticated(): void {
    this.oidcService.authorize();
  }
}
